import React, { useState, useEffect } from "react";
import { FaEye, FaEyeSlash, FaEdit } from "react-icons/fa";
import { services } from "../services";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";

const CreateAdmin = () => {
  const [formData, setFormData] = useState({
    adminName: "",
    mobile: "",
    email: "",
    password: "",
    adminType: "",
    state: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [admins, setAdmins] = useState([]);
  const [states, setStates] = useState([]);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingAdmins, setLoadingAdmins] = useState(false);
  const [error, setError] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingAdminId, setEditingAdminId] = useState(null);

  const fetchAdmins = async () => {
    try {
      setLoadingAdmins(true);
      const res = await services.requestSvc.get("/get-admins");
      setAdmins(res || []);
    } catch (err) {
      console.error("Error fetching admins:", err);
    } finally {
      setLoadingAdmins(false);
    }
  };
  useEffect(() => {
    fetchAdmins();
  }, []);
  useEffect(() => {
    const fetchStates = async () => {
      try {
        setLoadingStates(true);
        setError(null);
        const res = await services.requestSvc.get("/states-by-pincode");

        setStates(res || []);
      } catch (err) {
        console.error("Error fetching states:", err);
        setError("Failed to load states. Please try again.");
      } finally {
        setLoadingStates(false);
      }
    };

    fetchStates();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (isEditMode && editingAdminId) {
        const payload = {
          name: formData.adminName,
          email: formData.email,
          mobileNumber: formData.mobile,
          type: formData.adminType,
          stateName: formData.state,
          password: formData.password,
        };
        await services.requestSvc.put(
          `/update-admin/${editingAdminId}`,
          payload
        );
        toast.success("Admin updated successfully!");
      } else {
        const payload = {
          name: formData.adminName,
          email: formData.email,
          mobileNumber: formData.mobile,
          password: formData.password,
          type: formData.adminType,
          stateName: formData.state,
        };
        await services.requestSvc.post("/create-admin", payload);
        toast.success("Admin created successfully!");
      }
      setFormData({
        adminName: "",
        mobile: "",
        email: "",
        password: "",
        adminType: "",
        state: "",
      });
      setIsEditMode(false);
      setEditingAdminId(null);
      await fetchAdmins();
    } catch (error) {
      console.error("❌ Error creating admin:", error);
      toast.error("Failed to create admin");
    }
  };
  const handleEdit = (admin) => {
    setIsEditMode(true);
    setEditingAdminId(admin.id);
    setFormData({
      adminName: admin.name || "",
      mobile: admin.mobileNumber || "",
      email: admin.email || "",
      password: "",
      adminType: admin.type || "",
      state: admin.stateName || "",
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const columns = [
    {
      name: "Edit",
      selector: (row) => (
        <button
          className="text-blue-600 hover:text-blue-800"
          title="Edit Admin"
          onClick={() => handleEdit(row)}
        >
          <FaEdit />
        </button>
      ),
      width: "80px",
      center: true,
    },
    { name: "Name", selector: (row) => row.name || "-", sortable: true },
    { name: "Email", selector: (row) => row.email || "-", sortable: true },
    {
      name: "Mobile",
      selector: (row) => row.mobileNumber || "-",
      sortable: true,
    },
    { name: "Type", selector: (row) => row.type || "-", sortable: true },
    { name: "State", selector: (row) => row.stateName || "-", sortable: true },
  ];

  return (
    <div className="min-h-screen bg-gray-100 p-10">
      <div className="bg-white rounded-xl shadow-md p-8 w-full">
        <h2 className="text-3xl font-semibold mb-8 text-center text-gray-800">
          {isEditMode ? "Update Admin" : "Create Admin"}
        </h2>

        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Admin Name
            </label>
            <input
              type="text"
              name="adminName"
              value={formData.adminName}
              onChange={handleChange}
              placeholder="Enter admin name"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-blue-200"
              autoComplete="off"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Mobile Number
            </label>
            <input
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Enter mobile number"
              pattern="[0-9]{10}"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-blue-200"
              autoComplete="off"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Email <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email"
              required
              autoComplete="off"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-blue-200"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">
              {isEditMode ? "New Password" : "Password"}{" "}
              {!isEditMode && <span className="text-red-500">*</span>}
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder={
                  isEditMode
                    ? "Leave blank to keep existing password"
                    : "Enter password"
                }
                autoComplete="new-password"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-blue-200 pr-10"
                required={!isEditMode}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {isEditMode && (
              <p className="text-sm text-gray-500 mt-1">
                Leave blank to retain current password.
              </p>
            )}
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Admin Type <span className="text-red-500">*</span>
            </label>
            <select
              name="adminType"
              value={formData.adminType}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-4 py-2 bg-white focus:ring focus:ring-blue-200"
            >
              <option value="">Select admin type</option>
              <option value="super">Super</option>
              <option value="state">State</option>
              <option value="partner">Partner</option>
            </select>
          </div>

          {formData.adminType === "state" && (
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                State
              </label>
              <select
                name="state"
                value={formData.state}
                onChange={handleChange}
                disabled={loadingStates}
                className="w-full border border-gray-300 rounded-lg px-4 py-2 bg-white focus:ring focus:ring-blue-200"
              >
                <option value="">
                  {loadingStates
                    ? "Loading states..."
                    : error
                    ? "Error loading states"
                    : "Select state"}
                </option>
                {states.map((s) => (
                  <option key={s.standardStateName} value={s.standardStateName}>
                    {s.standardStateName}
                  </option>
                ))}
              </select>
              {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
            </div>
          )}

          <div className="md:col-span-2 flex justify-end mt-6">
            <button
              type="submit"
              className={`${
                isEditMode ? "btn-primary" : "btn-primary"
              } text-white font-semibold py-2 px-6 rounded-lg w-full md:w-1/3 transition duration-200`}
            >
              {isEditMode ? "Update Admin" : "Create Admin"}
            </button>
          </div>
        </form>
      </div>
      <div className="bg-white rounded-xl shadow-md p-6 mt-10">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">
          All Admins
        </h3>
        <DataTable
          columns={columns}
          data={admins}
          progressPending={loadingAdmins}
          pagination
          customStyles={{
            table: {
              style: {
                overflow: "hidden",
                borderRadius: "8px 8px 0px 0px",
                border: "1px solid rgba(0,0,0,0.4)",
                borderLeft: "0",
              },
            },
            headRow: {
              style: {
                background: "#b1c7e9",
                color: "#3D3D3D",
                fontWeight: "600",
                "&:hover": {
                  cursor: "pointer",
                },
              },
            },
            headCells: {
              style: {
                border: "1px solid rgba(0,0,0,0.4)",
                borderTop: "0",
                borderRight: "0",
                borderBottom: "0",
              },
            },
            cells: {
              style: {
                borderLeft: "1px solid rgba(0,0,0,0.4)",
              },
            },
            rows: {
              style: {
                backgroundColor: "#fff",
                cursor: "default",
                color: "#656363",
                fontSize: "14px",
                "&:hover": {
                  cursor: "default",
                  backgroundColor: "#E9E9E9",
                },
                borderBottom: "1px solid rgba(0,0,0,0.4)",
              },
            },
            pagination: {
              style: {
                backgroundColor: "rgba(0, 0, 0, 0.05)",
                borderRadius: "0.375rem",
                borderTopLeftRadius: "0px",
                borderTopRightRadius: "0px",
                border: "1px solid rgba(0,0,0,0.4)",
                borderTop: "0",
                fontWeight: "500",
                color: "rgb(61, 61, 61)",
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default CreateAdmin;
